import { LineChart, LineChartProps } from '../../../renderers/line-chart/line-chart.component';
import { TRANSACTION_VOLUME_LINE_CHART_DEFINITION } from './transaction-volume-line-chart.definition';
import { TRANSACTION_VOLUME_LINE_CHART_MOCK_DATA } from './transaction-volume-line-chart.mock';

export const TransactionVolumeLineChart = ({ showArea = true, ...props }: LineChartProps) => (
    <LineChart
        {...props}
        showArea={showArea}
    />
);

TransactionVolumeLineChart.definition = TRANSACTION_VOLUME_LINE_CHART_DEFINITION;
TransactionVolumeLineChart.mockData = TRANSACTION_VOLUME_LINE_CHART_MOCK_DATA;
